import { useEffect, useState } from 'react';
import api from '../api';

// The retailer's held gateway onboardings (still waiting for the gateway to come online).
// `reloadToken` refetches, the same way the gateways list refetches after a delete.
const useHeldGatewayOnboardings = (reloadToken = 0) => {
    const [state, setState] = useState({ isReady: false, isError: false, data: [] });

    useEffect(() => {
        let active = true;
        api.get_pending_gateway_onboardings()
            .then(res => active && setState({ isReady: true, isError: false, data: res.data || [] }))
            .catch(() => active && setState({ isReady: true, isError: true, data: [] }));
        return () => {
            active = false;
        };
    }, [reloadToken]);

    return state;
};

export default useHeldGatewayOnboardings;
